module.exports = __webpack_public_path__ + "static/studio-03-b460f046e1a56bcb4806dcc0cbe17fe5.webp";